import { useContext } from 'react';

import { AlternativeRegistrationModalContext } from './alternative-registration-modal-provider';

function useAlternativeRegistrationModal() {
  const context = useContext(AlternativeRegistrationModalContext);

  if (!context) {
    throw new Error(
      'useAlternativeRegistrationModal must be used within a AlternativeRegistrationModalProvider',
    );
  }

  return context;
}

export { useAlternativeRegistrationModal };
